import React from "react";
import { adminTheme } from "styles/adminTheme";

export default function AdminCard({ title, subtitle, action, children }) {
    return (
        <div
            style={{
                background: "rgba(255,255,255,0.92)", // hellere Card (wie in deinem Screenshot)
                borderRadius: adminTheme.radius.lg,
                padding: adminTheme.spacing.lg,
                border: `1px solid ${adminTheme.colors.border}`,
                boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
                backdropFilter: "blur(2px)",
            }}
        >
            {(title || action) && (
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                    <div>
                        {title && (
                            <div style={{ fontSize: 22, fontWeight: 700, color: "#0f172a" }}>
                                {title}
                            </div>
                        )}
                        {subtitle && (
                            <div style={{ marginTop: 4, color: "#64748b", fontSize: 13 }}>
                                {subtitle}
                            </div>
                        )}
                    </div>
                    {action && <div>{action}</div>}
                </div>
            )}

            <div style={{ marginTop: title || action ? 18 : 0 }}>{children}</div>
        </div>
    );
}
